<script lang="ts">
	import CmsPageShell from '$components/Page/CmsPageShell.svelte';
	import LandingPageComponent from '$components/Page/LandingPage.svelte';
	import type { LandingPage } from '$models/Page/LandingPage';

	let { page }: { page: LandingPage } = $props();
</script>

<CmsPageShell {page}>
	<LandingPageComponent {page} />
</CmsPageShell>
